/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_HelpInputs */

const en_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the template format for your CCSL export`)
};

const fr_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez le format de modele pour votre exportation CCSL`)
};

const de_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das Vorlagenformat für Ihren CCSL-Export aus.`)
};

const it_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il formato del modello per l'esportazione CCSL`)
};

const ru_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите формат шаблона для экспорта в CCSL.`)
};

const es_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el formato de plantilla para su exportación CCSL`)
};

const zh_cn2_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 CCSL 导出模板格式`)
};

const ja_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSLエクスポートのテンプレート形式を選択します`)
};

const hi_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने CCSL निर्यात के लिए टेम्पलेट प्रारूप चुनें`)
};

const pt_pt2_ccsl_export_template_help = /** @type {(inputs: Ccsl_Export_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o formato do modelo para sua exportação CCSL.`)
};

/**
* | output |
* | --- |
* | "Select the template format for your CCSL export" |
*
* @param {Ccsl_Export_Template_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_help = /** @type {((inputs?: Ccsl_Export_Template_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_template_help(inputs)
	if (locale === "de") return de_ccsl_export_template_help(inputs)
	if (locale === "it") return it_ccsl_export_template_help(inputs)
	if (locale === "ru") return ru_ccsl_export_template_help(inputs)
	if (locale === "es") return es_ccsl_export_template_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_template_help(inputs)
	if (locale === "ja") return ja_ccsl_export_template_help(inputs)
	if (locale === "hi") return hi_ccsl_export_template_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_template_help(inputs)
	return en_ccsl_export_template_help(inputs)
});